"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = undefined;

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _themed = require("../../utils/themed");

var _themed2 = _interopRequireDefault(_themed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Text = exports.Text = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Text",
  componentId: "sc-3w8eiy-0"
})(["", " ", ""], (0, _themed2.default)("Text"), p => p.bold ? "font-family: Uni Neue Heavy" : "font-family: Uni Neue");

Text.defaultProps = {
  fontFamily: "Uni Neue",
  letterSpacing: 0.3
};

/** @component */
exports.default = Text;